import { api, crud } from "./api";

export const ICRA_DURUMLARI = [
    { value: "BASLATILDI", label: "Başlatıldı" },
    { value: "TAKIPTE", label: "Takipte" },
    { value: "TAHSIL_EDILDI", label: "Tahsil Edildi" },
    { value: "KAPANDI", label: "Kapandı" },
];

export const icraMerkez = {
    list: (params) => crud.list("icralar", params),
    retrieve: (id) => crud.retrieve("icralar", id),
    update: (id, payload) => crud.update("icralar", id, payload),
    ozet: () => api.get("/v1/admin/icralar/ozet/").then((r) => r.data),
    kanban: (params) =>
        api.get("/v1/admin/icralar/kanban/", { params }).then((r) => r.data),
    odemeler: (id) =>
        api.get(`/v1/admin/icralar/${id}/odemeler/`).then((r) => r.data),
    tahsilatKaydi: (id, payload) =>
        api
            .post(`/v1/admin/icralar/${id}/tahsilat-kaydi/`, payload)
            .then((r) => r.data),
    senkronTahsilat: (id) =>
        api.post(`/v1/admin/icralar/${id}/senkron-tahsilat/`).then((r) => r.data),
};
